// 邀请列表页面接口
import { request } from "@/utils/requset.js";

export function lists(data) {
  return request({
    url: "/api/content.agreement/lists",
    method: "post",
    data,
  });
}
// 内容详情
export function details(data) {
  return request({
    url: "/api/content.agreement/details",
    method: "post",
    data,
  });
}
// 内容编辑
export function renew(data) {
  return request({
    url: "/api/content.agreement/renew",
    method: "post",
    data,
  });
}
